import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { ICON_SIZE, INFO_WITH_ICONS_MARGIN } from '../../constants';
import { getPx } from '../../helpers/common';
import { ellipsisStyle } from '../../tokens/ellipsis';
import { InfoWithIconsPlaceholder } from './components/InfoWithIconsPlaceholder';
import { InfoWithIconsWrapper } from './components/InfoWithIconsWrapper';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../helpers/media-style';
const IconPlaceholderLeft = styled(InfoWithIconsPlaceholder)`
  ${({
  $iconMargin,
  $noMargin,
  $vertical
}) => styleArrayForBreakpoints([$iconMargin, $noMargin, $vertical], ([$iconMargin, $noMargin, $vertical]) => $vertical ? `margin-bottom: ${getPx($noMargin ? 0 : $iconMargin)};` : `margin-right: ${getPx($noMargin ? 0 : $iconMargin)};`)}
`;
const IconPlaceholderRight = styled(InfoWithIconsPlaceholder)`
  ${({
  $iconMargin,
  $noMargin,
  $vertical
}) => styleArrayForBreakpoints([$iconMargin, $noMargin, $vertical], ([$iconMargin, $noMargin, $vertical]) => $vertical ? `margin-top: ${getPx($noMargin ? 0 : $iconMargin)};` : `margin-left: ${getPx($noMargin ? 0 : $iconMargin)};`)}
`;
const ChildrenWrapper = styled.span`
  ${({
  $withOverflowHidden
}) => $withOverflowHidden ? `overflow: hidden;` : ''}
  ${({
  $fullWidth,
  $vertical
}) => styleForBreakpoints($vertical, $vertical => !$vertical && $fullWidth ? `flex-grow: 1;` : '')}
  ${({
  $ellipsis,
  $vertical
}) => styleForBreakpoints($vertical, $vertical => !$vertical && $ellipsis ? `
          overflow: hidden;
          min-width: 0;
          display: inline-block;
          ${ellipsisStyle}
        ` : '')}
  ${({
  $noDisplay
}) => styleForBreakpoints($noDisplay, $noDisplay => $noDisplay ? `display: none;` : '')}
`;
const InfoWithIconsSimple = ({
  ellipsis = false,
  fullWidth = false,
  fullInnerWidth = false,
  withInnerOverflowHidden = false,
  multiline = false,
  lineHeight,
  icon,
  iconRight,
  iconMargin = INFO_WITH_ICONS_MARGIN,
  iconRightMargin = INFO_WITH_ICONS_MARGIN,
  iconWidth = ICON_SIZE,
  iconRightWidth = ICON_SIZE,
  iconHeight = ICON_SIZE,
  iconRightHeight = ICON_SIZE,
  iconTopPosition,
  iconRightTopPosition,
  vertical = false,
  noChildren = false,
  component: Component,
  children,
  ...props
}) => icon || iconRight ? /*#__PURE__*/React.createElement(InfoWithIconsWrapper, _extends({
  $vertical: vertical,
  $fullWidth: fullWidth
}, props), icon && /*#__PURE__*/React.createElement(IconPlaceholderLeft, {
  $vertical: vertical
  // @ts-expect-error Special type
  ,
  $lineHeight: lineHeight ?? Component?._size?.lineHeight,
  $multiline: multiline,
  $noMargin: noChildren,
  $iconMargin: iconMargin,
  $iconWidth: iconWidth,
  $iconHeight: iconHeight,
  $iconTopPosition: iconTopPosition
}, icon), /*#__PURE__*/React.createElement(ChildrenWrapper, {
  $noDisplay: noChildren,
  $vertical: vertical,
  $fullWidth: fullInnerWidth,
  $withOverflowHidden: withInnerOverflowHidden,
  $ellipsis: ellipsis
}, children), iconRight && /*#__PURE__*/React.createElement(IconPlaceholderRight, {
  $vertical: vertical
  // @ts-expect-error Special type
  ,
  $lineHeight: lineHeight ?? Component?._size?.lineHeight,
  $multiline: multiline,
  $noMargin: noChildren,
  $iconMargin: iconRightMargin,
  $iconWidth: iconRightWidth,
  $iconHeight: iconRightHeight,
  $iconTopPosition: iconRightTopPosition
}, iconRight)) : children;
export default InfoWithIconsSimple;